import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, Form, FormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';
import { AppConfig } from '../../app.config';
import { DatastoreService } from '../../services/datastore.service';
import { ApiService } from '../../services/jrni/api.service';
import { FormBuilderService } from '../../services/form-builder.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { environment } from '../../../environments/environment';
import { AddressLookupStatusComponent } from '@bookinglab/hwrc-ui';

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit {

  @Input() formId: string;
  @Input() formData: any = false;
  @Input() showSubmit: boolean = true;
  @Input() submitted: boolean = false;
  @Input() useCloseButtons: boolean = false;
  @Input() maxChildren: number = 4;
  @Input() idx: number = -1;
  @Input() overrideCounter: string;
  @Input() allData = []
  @Output() formSubmitted = new EventEmitter<FormGroup>();
  @Output() formStatus = new EventEmitter<any>();

  formFields: any[] = [];
  formGroups: any = {};
  childForms: any[] = [];

  detailsTitle: string = '';
  children: any[] = [[]];
  vehicleStatus: any = [];

  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMapRegister;

  restrictedVehiclesLimitExceed: boolean = false
  firstExtraRestricted: number = this.maxChildren + 1;
  showingAddresses: boolean = false;
  addresses: any = [];
  addressId: number;

  regExPostcode = new RegExp('^[A-Z]{1,2}\\d{1,2}[A-Z\\d]? ?\\d[A-Z]{2}$')
  json = JSON
  fullAddressArray = []
  constructor(
    public formService: FormBuilderService,
    public dataStoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private departmentService: DepartmentService,
    private apiService: ApiService,
    public addressLookupStatusComponent: AddressLookupStatusComponent,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  async ngOnInit(): Promise<void> {
    console.log('max children', this.maxChildren);
    this.spinner.show()

    if (this.formData) {
      if (this.formData[0]) {
        if (Object.keys(this.formData[0]).length > 0) {
          await this.prePopulateForms(true);
          this.spinner.hide()
          return
        }
      }
    }
    await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.dataStoreService.config)
    await this.populateForms(true);
    this.spinner.hide()

  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('formData')) {
      // get the data to add to form
      this.populateForms(changes.formData.currentValue['hafId']);
    }
  }

  async addChild() {
    if (this.children.length < this.maxChildren) {
      const formGroup = await this.formService.buildForm(this.formId, []);
      const formFields = this.formService.getFields(this.formId);

      this.addresses.push([])
      this.childForms.push(formGroup);
      this.formFields.push(formFields);
      this.children.push([]);

      this.formChanges(this.children.length - 1);

      const script = this.renderer.createElement('script');
      script.type = 'application/javascript';
      script.text = `window.setTimeout(function(){document.getElementById('summary-child-${this.children.length}').click();}, 100);`;

      this.renderer.appendChild(this.doc.body, script);

    }
  }

  removeChild() {
    if (this.children.length > 1) {
      this.children.pop();
      this.addresses.pop();
      this.formChanges(this.children.length - 1);
    }
  }

  removeChildAtIndex(idx: number) {
    console.log("clicked")
    if (this.children.length > 1) {
      this.children.splice(idx, 1);
      this.childForms.splice(idx, 1);
      this.formFields.splice(idx, 1);
      for (const idx in this.children) {
        this.formChanges(parseInt(idx));
        this.forceRevalidationForIndex(parseInt(idx));
      }
    }
  }

  async submit(formId: string) {
    this.formSubmitted.emit(this.formGroups[this.formId]);
  }

  formChanges(idx: number) {
    this.childForms[idx].valueChanges.subscribe((selectedValue: any) => {
      console.log("formChanges", this.children[idx])
      if (this.children[idx]) {
        let currentChild = this.children[idx];
        // now get the values and place them into the array
        // populate the current child
        for (const field of this.formFields[idx]) {
          if (selectedValue.hasOwnProperty(field.field)) {
            const inputtedValue = selectedValue[field.field];
            const foundKey = currentChild.find((f: any) => f.field === field.field);
            if (foundKey) {
              foundKey.value = inputtedValue;
            }
            else {
              currentChild.push({ field: field.field, value: inputtedValue });
            }
          }
        }

        // update validators based on conditional fields
        for (const field of this.formFields[idx]) {
          const control: FormControl = this.childForms[idx].get(field.field);
          if (field.conditional) {
            const trigger = this.childForms[idx].get(field.trigger);
            // get value of trigger
            // doing it this way did not work. 
            // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
            // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
            // if (trigger.value !== field.conditional_value) {
            //   // control.setValidators([]); 
            // }
            // else {
            //   // control.setValidators([Validators.required]);
            // }
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
        this.forceRevalidationForIndex(idx);
      }


    });
  }

  forceRevalidationForIndex(idx: number) {
    const hasErrors: any[] = [];
    for (const field of this.formFields[idx]) {
      const control: FormControl = this.childForms[idx].get(field.field);
      if (field.conditional) {
        const trigger = this.childForms[idx].get(field.trigger);
        // get value of trigger
        // doing it this way did not work. 
        // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
        // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
        // if (trigger.value !== field.conditional_value) {
        //   // control.setValidators([]);
        // }
        // else {
        //   // control.setValidators([Validators.required]);
        // }
        control.updateValueAndValidity({ onlySelf: true });
      }
    }

    for (const field of this.formFields[idx]) {
      const control = this.childForms[idx].get(field.field);
      if (control && !control.disabled) {
        field.value = control.value;
      }
      if (control && control.errors && !control.disabled) {
        console.log("has err", control, control.errors, !control.disabled)
        hasErrors.push({
          field: field,
          control: control
        });
      }
    }

    this.dataStoreService.childrenToRegister = this.children;

    console.log(this.children)
    let restrictedCount = 0;
    for (let i in this.children) {
      const child = this.children[i]
      const rv = child.find((x) => x.field === "is_this_a_restricted_vehicle")
      if (rv) {
        if (rv.value === "true") {
          restrictedCount++
          if (restrictedCount === 2) {
            this.firstExtraRestricted = parseInt(i)
          }
        }
      }
    }


    if (restrictedCount > 1) {
      this.restrictedVehiclesLimitExceed = true
      for (let child of this.children) {
        const rv = child.find((x) => x.field === "is_this_a_restricted_vehicle")
        const control = this.childForms[idx].get(rv.field);
        if (rv.value === "true") {
          console.log("has err")
          hasErrors.push({
            field: rv.field,
            control: control
          });
        }
      }
    } else {
      this.restrictedVehiclesLimitExceed = false
    }
    console.log(hasErrors)
    if (hasErrors.length > 0) {
      this.formStatus.emit({
        status: false,
        errors: hasErrors,
        formId: this.formId,
      });
    }
    else {
      this.formStatus.emit({
        status: true,
        errors: [],
        data: this.childForms,
        formId: this.formId,
        idx: this.idx.toString()
      });
    }
    console.log("ids", this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId])
  }


  async populateForms(formDataKey: any) {
    let parentDepartment = await this.departmentService.getParentDepartment();
    const pId = parentDepartment.id;
    const pClient = parentDepartment.self.split('://')[1].split('.')[0];
    const token: any = await this.apiService.getToken(pClient, pId);
    if (token) {
      environment.clientToken = token.token;
    }
    const config = await this.apiService.getConfig(pClient, pId);

    this.dataStoreService.config = config;
    console.log("  this.dataStoreService.config", this.dataStoreService.config)
    if (formDataKey) {

      let foundChild: any = false;

      const formGroup = await this.formService.buildForm(this.formId, []);
      const formFields = this.formService.getFields(this.formId);
      console.log(formGroup)
      console.log(formFields)

      for (const [idx, child] of this.children.entries()) {
        this.addresses.push([])
        this.childForms.push(formGroup);
        this.formFields.push(formFields);
        this.formGroups[this.formId] = formGroup;
        this.detailsTitle = this.formService.getDetailsTitle(this.formId);
        // now set up changes
        this.formChanges(idx);
      }

      const script = this.renderer.createElement('script');
      script.type = 'application/javascript';
      script.text = `window.setTimeout(function(){document.getElementById('summary-child-1').click();}, 100);`;

      this.renderer.appendChild(this.doc.body, script);
    }
  }

  async prePopulateForms(formDataKey: any) {

    if (formDataKey) {

      let foundChild: any = false;

      const idx = 1;

      this.detailsTitle = this.formService.getDetailsTitle(this.formId);
      console.log(" this.formData", this.formData)
      if (this.formData[0]) {
        for (let i in this.formData) {
          const formGroup = await this.formService.buildForm(this.formId, []);
          const formFields = this.formService.getFields(this.formId);

          this.addresses.push([])
          this.childForms.push(formGroup);
          this.formFields.push(formFields);
          const form = this.formData[i]
          this.formGroups[this.formId] = formGroup;
          console.log(i, form)
          if (parseInt(i) > 0) {
            this.children.push([]);
          }
          console.log(this.formFields, i)
          for (let field of this.formFields[parseInt(i)]) {
            if (field.field !== 'address') {
              field.value = form[field.field]
              this.childForms[i].controls[field.field].setValue(form[field.field])
              if (field.field === 'postcode' && form[field.field]) {
                if (this.addressLookupStatusComponent.getAddressLookupUnavailable()) {
                    this.childForms[i].controls['address'].setValue(form['address'])
                } else {
                  await this.getAddress(i, false)
                  if (form['address']) { // if an address was selected, populate it
                    // can't actually set the select input til the select input exists
                    this.childForms[i].controls['address'].setValue(form['address'])
                    const intervalId = setInterval(() => this.untilDone(intervalId, i, form['address']), 100);
                  }
                }
              }
            }
            // if (formGroup.controls[field.field]) {
            //   formGroup.controls[field.field].setValue(field.value)
            // } else {
            //   console.log("skipped ", field)
            // }
          }
          this.forceRevalidationForIndex(parseInt(i));

        }
      }
      // now set up changes
      // this.formChanges(idx);

      const script = this.renderer.createElement('script');
      script.type = 'application/javascript';
      script.text = `window.setTimeout(function(){document.getElementById('summary-child-1').click();}, 100);`;

      this.renderer.appendChild(this.doc.body, script);

    }
  }

  untilDone(me, i, value) {
    // keep trying to find the select input, then when we do, set the control value (which sets the select option) and then stop checking
    let element: any = document.getElementById(`select-${i}-address`);
    if (element) {
      this.childForms[i].controls['address'].setValue(value)
      clearInterval(me);
    }

    return
  }

  keypressOnRadio(event: any) {

    if (event.code === "Enter") {
      let evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      event.srcElement.children[0].dispatchEvent(evt);
    }
  }

  resetVehicleDetails(idx) {
    console.log("here")
    this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue("");
    this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue("");
    // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

    this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue("");
    this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue("");
  }

  async getVehicle(idx) {
    this.spinner.show();
    let vehiclereg: String = this.childForms[idx].value[this.dvlaLookupQuestionMap.regQuestionId];
    this.childForms[idx].duplicateAddressError = false;

    //check if this is a duplicate
    let myIdx = idx
    if (this.idx !== -1) {
      myIdx = this.idx
    } else {
      this.allData = []
      for (let form of this.childForms) {
        const dummyVehicle: any = {}
        if (form.value[this.dvlaLookupQuestionMap.regQuestionId]) {
          dummyVehicle.vehicle_registration = form.value[this.dvlaLookupQuestionMap.regQuestionId]
        }
        this.allData.push(dummyVehicle)
      }
    }
    for (let d in this.allData) {
      if (this.allData[d].vehicle_registration === vehiclereg && d.toString() !== myIdx.toString()) {
        console.log("ERROR, DUPLICATE!")
        this.childForms[idx].controls[this.dvlaLookupQuestionMap.regQuestionId].setValue("");
        this.childForms[idx].controls[this.dvlaLookupQuestionMap.regQuestionId].patchValue("");
        this.childForms[idx].duplicateAddressError = true
        this.spinner.hide()
        return
      }
    }
    if (vehiclereg) {
      this.allData[myIdx].vehicle_registration = vehiclereg
    }

    try {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(vehiclereg);

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(' ', vehicleLookup.message.indexOf(':') + 1); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(indexOfErrorCode + 1, indexOfErrorCode + 4);

        if (statusCodeErrorMessage == "404") {
          this.vehicleStatus[idx] = 2;
        } else {
          this.vehicleStatus[idx] = 3;
        }
        // this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].enable()
        // this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].enable()

      } else {

        this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicleLookup['result'].make);
        this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicleLookup['result'].make);
        // this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

        this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicleLookup['result'].colour);
        this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicleLookup['result'].colour);
        // this.childForms[idx].controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()
        this.childForms[idx].controls[this.dvlaLookupQuestionMap.makeQuestionId].updateValueAndValidity({ onlySelf: true });

        this.vehicleStatus[idx] = 1;

      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }

  }


  async getAddress(idx: any, repopulate: boolean = null) {

    this.showingAddresses = false;

    try {
      // Clear the addresses array
      this.addresses[idx].length = 0;
      console.log(idx)
      console.log(this.formFields[idx])
      console.log(this.childForms[idx])
      this.childForms[idx].controls.address.setValue("");

      // Custom error handling for postcode
      let postcode: String = this.childForms[idx].value.postcode.replace(/\s/g, '');
      this.childForms[idx].controls.postcode.setValue(postcode)
      if (this.childForms[idx].controls.postcode.status == 'INVALID') {
        this.childForms[idx].get("postcode").setErrors({ 'invalidPostcode': this.translateService.instant('COMMON.INVALID_POSTCODE') })
        return;
      }

      this.spinner.show();
      const res = await this.apiService.get(this.childForms[idx].value.postcode)
      console.log("res", res)
      if (this.childForms[idx].controls.postcode.errors && this.childForms[idx].controls.postcode.errors.invalidPostcode) {
        delete this.childForms[idx].controls.postcode.errors.invalidPostcode;
      }
      var object: any = res;
      if (object?.results) {
        if (this.childForms[idx].controls.postcode.errors && this.childForms[idx].controls.postcode.errors.addressNotFound) {
          delete this.childForms[idx].controls.postcode.errors.addressNotFound;
        }
        var addresses = object.results;

        const addressesExist = addresses.filter(e => {
          if (e.DPA) {
            return true;
          } else if (e.LPI) {
            return true;
          }
        });

        const addressException = await this.apiService.getAddressException();
        let expections = [];

        if (addressException) {
          expections = addressException['Items'];
        }

        let added = [];

        if (addressesExist.length > 1) {
          // If it matches up, push the addresses
          let localCodes = [];
          addressesExist.forEach((item) => {

            const expectionAddress = expections.find(({ UPRN }) => {

              if (item.DPA) {
                if (UPRN === item.DPA.UPRN) {
                  return true;
                }
              }
              if (item.LPI) {
                if (UPRN === item.LPI.UPRN) {
                  return true;
                }
              }

              return false;

            });

            const addedAlready = added.find(({ ADDRESS }) => {

              if (item.DPA) {
                if (ADDRESS === item.DPA.ADDRESS) {
                  return true;
                }
              }
              if (item.LPI) {
                if (ADDRESS === item.LPI.ADDRESS) {
                  return true;
                }
              }

              return false;

            });

            let alreadyEntered = false;

            if (expectionAddress === undefined) {
              alreadyEntered = this.addresses[idx].some(e => {
                if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                  return true;
                } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                  return true;
                }
              });
            }

            if (!alreadyEntered && addedAlready === undefined) {


              if (item.DPA) {
                // const inLocalArea = this.checkAddress(item.DPA);
                // if (inLocalArea) {
                this.addresses[idx].push({ address: item.DPA });
                added.push({ ADDRESS: item.DPA.ADDRESS },);
                // localCodes.push(inLocalArea);
                // }
              } else {
                // const inLocalArea = this.checkAddress(item.LPI);
                // if (inLocalArea) {
                this.addresses[idx].push({ address: item.LPI });
                added.push({ ADDRESS: item.LPI.ADDRESS },);
                //   localCodes.push(inLocalArea);
                // }
              }
            }
          });

          if (repopulate) {
            let address = this.childForms[idx].value.address.address.ADDRESS
            for (let i = 0; i < this.addresses[idx].length; i++) {
              let item = this.addresses[i]
              if (address == item.address.ADDRESS) {
                this.addressId = i;
              }
            }
          }

          // if (localCodes.length > 0) {
          //   this.showingAddresses = true;
          //   this.isInLocalArea = true;
          // }
          // else {
          //   this.showingAddresses = true;
          //   this.isInLocalArea = false;
          // }
        } else {
          // If it doesn't match up, show an error message
          this.childForms[idx].get("postcode").setErrors({ 'invalidPostcode': this.translateService.instant('COMMON.ADDRESS_NOT_ELIGIBLE') })
        }
      } else {
        this.childForms[idx].get("postcode").setErrors({ 'addressNotFound': this.translateService.instant('COMMON.ADDRESS_NOT_FOUND') })
      }
    } catch (error) {
      console.log(error);
      await this.addressLookupStatusComponent.checkAddressLookupStatus(AppConfig, environment, this.dataStoreService.config)
      this.spinner.hide();
    }
    this.spinner.hide();
  }

  localAddress(address) {
    return this.formService.localAddress(address)
  }

  checkAddresses(idx) {
    console.log("checkAddresses", idx)
    const address = this.childForms[idx].value["address"]
    console.log(address)
    this.childForms[idx].duplicateAddressError = false

    //check if this is a duplicate
    let myIdx = idx
    if (this.idx !== -1) {
      myIdx = this.idx
    } else {
      this.allData = []
      for (let form of this.childForms) {
        const dummyVehicle: any = {}
        if (form.value["address"]) {
          dummyVehicle.address = form.value["address"]
        }
        this.allData.push(dummyVehicle)
      }
    }
    console.log(this.allData)
    for (let d in this.allData) {
      if (this.allData[d].address === address && d.toString() !== myIdx.toString()) {
        console.log("ERROR, DUPLICATE!")
        this.childForms[idx].controls["address"].setValue("");
        this.childForms[idx].controls["address"].patchValue("");
        this.childForms[idx].duplicateAddressError = true
        this.spinner.hide()
        return
      }
    }
    if (address) {
      this.allData[myIdx].address = address
    }
    this.forceRevalidationForIndex(idx);
  }

  getPostcodeDetails(address, idx) {
    return this.addresses[idx].find((x) => x.address.ADDRESS === address)
  }
}
